import React, { useMemo, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NewGlobalDataTable.css';

const NewGlobalDataTable = ({
  columns,
  data,
  tableName,
  setPageSize,
  setPageNumber,
  totalRecord,
  rowsPerPageOptions = [10, 20, 30],
  
}) => {
   data = Array.isArray(data) ? data : [];
  const [searchText, setSearchText] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [page, setPage] = useState(1);
  const [rowsPerPage, updateRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [columnWidths, setColumnWidths] = useState({});

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const handleRowsPerPageChange = (event) => {
    const newSize = Number(event.target.value);
    updateRowsPerPage(newSize);
    setPageSize(newSize);
    setPage(1);
    setPageNumber(1);
  };

  const handlePageChange = (direction) => {
    const newPage = Math.max(1, page + direction);
    setPage(newPage);
    setPageNumber(newPage);
  };

  const handleSort = (columnIndex) => {
    const key = columns[columnIndex].name;
    const direction =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';

    setSortConfig({ key, direction });
  };

  const startResize = (e, index) => {
    e.preventDefault();
    const startX = e.clientX;
    const th = e.target.parentElement;
    const startWidth = th.offsetWidth;

    const handleMouseMove = (moveEvent) => {
      const newWidth = Math.max(60, startWidth + moveEvent.clientX - startX);
      setColumnWidths((prev) => ({ ...prev, [index]: `${newWidth}px` }));
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Search & sort only on current data (not paginating client-side)
  const filteredData = useMemo(() => {
    let tempData = [...data];

    if (searchText) {
      tempData = tempData.filter(item =>
        columns.some(column => {
          const val = column.selector?.(item);
          return val && val.toString().toLowerCase().includes(searchText.toLowerCase());
        })
      );
    }

    if (sortConfig.key) {
      const column = columns.find(col => col.name === sortConfig.key);
      if (column && column.sortable) {
        tempData = [...tempData].sort((a, b) => {
          const valA = column.selector?.(a);
          const valB = column.selector?.(b);
          if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
          if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
          return 0;
        });
      }
    }

    return tempData;
  }, [data, searchText, sortConfig, columns]);

  //const totalPages = Math.ceil(totalRecord / rowsPerPage);
const totalPages = Math.ceil(Number(totalRecord) / Number(rowsPerPage));

  return (
    <div className="datatable-container p-3 border rounded">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold text-dark">{tableName}</h5>

        <input
          type="text"
          value={searchText}
          onChange={handleSearch}
          placeholder="Search"
          className="form-control w-25"
        />
      </div>

      <table className="table table-bordered table-hover table-striped table-sm text-center align-middle">
        <thead className="table-primary">
          <tr>
            {columns.map((col, index) => (
              <th
                key={index}
                onClick={() => col.sortable && handleSort(index)}
                style={{
                  cursor: col.sortable ? 'pointer' : 'default',
                  position: 'relative',
                  width: columnWidths[index] || 'auto',
                }}
              >
                {col.name}
                {sortConfig.key === col.name && (
                  <small className="ms-1">
                    {sortConfig.direction === 'asc' ? '▲' : '▼'}
                  </small>
                )}
                <div
                  className="resize-handle"
                  onMouseDown={(e) => startResize(e, index)}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      width: columnWidths[colIndex] || 'auto',
                      wordBreak: 'break-word'
                    }}
                  >
                    {col.cell ? col.cell(row) : col.selector?.(row)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-muted">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="d-flex justify-content-between align-items-center">
        <div>
          Rows per page:{' '}
          <select
            value={rowsPerPage}
            className="form-select d-inline-block w-auto ms-2"
            onChange={handleRowsPerPageChange}
          >
            {rowsPerPageOptions.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>

        <div>
          Page {page} of {totalPages}
          &nbsp;
          <button
            className="btn btn-outline-secondary btn-sm me-2"
            onClick={() => handlePageChange(-1)}
            disabled={page === 1}
          >
            Previous
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => handlePageChange(1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewGlobalDataTable;
